export default __webpack_public_path__ + "static/media/216.10fda3fc.jpg";